import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Card } from 'react-bootstrap';
import ProductSelector from '../Global/ProductSelector';
import { updateProductScoresBatch } from '../../api';

const ScoreUpdateModal = ({ show, onHide, onApply, onBack, product, newScore, oldScore, embedded = false }) => {
    const [selectedCriteria, setSelectedCriteria] = useState({
        typeId: '',
        modelId: '',
        colorId: '',
        sizeId: ''
    });
    const [applyToAll, setApplyToAll] = useState(false);

    const handleSelectionChange = (selection) => {
        setSelectedCriteria({
            typeId: selection.typeId,
            modelId: selection.modelId,
            colorId: selection.colorId,
            sizeId: selection.sizeId
        });
    };

    // Reset dependent fields when parent changes
    const handleCriteriaChange = (field, value) => {
        let newCriteria = { ...selectedCriteria };
        
        if (field === 'typeId') {
            newCriteria = {
                typeId: value,
                modelId: '',
                colorId: '',
                sizeId: ''
            };
        } else if (field === 'modelId') {
            newCriteria = {
                ...newCriteria,
                modelId: value,
                colorId: '',
                sizeId: ''
            };
        } else if (field === 'colorId') {
            newCriteria = {
                ...newCriteria,
                colorId: value,
                sizeId: ''
            };
        } else {
            newCriteria[field] = value;
        }
        
        setSelectedCriteria(newCriteria);
    };

    const handleApply = async () => {
        try {
            const scoreUpdateRequest = {
                newScore: newScore,
                criteria: applyToAll ? {
                    typeId: selectedCriteria.typeId || null,
                    modelId: selectedCriteria.modelId || null,
                    colorId: selectedCriteria.colorId || null,
                    sizeId: selectedCriteria.sizeId || null
                } : null
            };
            
            await updateProductScoresBatch(scoreUpdateRequest);
            onApply();
        } catch (error) {
            console.error('Error updating scores:', error);
            // TODO: Mostrar error al usuario
        }
    };

    const getCriteriaDescription = () => {
        const parts = [];
        if (selectedCriteria.typeId) parts.push('mismo tipo');
        if (selectedCriteria.modelId) parts.push('mismo modelo');
        if (selectedCriteria.colorId) parts.push('mismo color');
        if (selectedCriteria.sizeId) parts.push('mismo tamaño');
        
        if (parts.length === 0) return 'ningún producto adicional';
        return `productos con ${parts.join(', ')}`;
    };

    const content = (
        <>
            <Alert variant="info" className="mb-4">
                <strong>Producto actual:</strong> {product?.type?.typeName} - {product?.model?.modelName} - {product?.color?.colorName} - {product?.size?.size}
                <br />
                <strong>Puntuación:</strong> {oldScore} → {newScore}
            </Alert>

            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">¿Aplicar este cambio a otros productos?</h6>
                </Card.Header>
                <Card.Body>
                    <Form.Check
                        type="radio"
                        id="apply-none"
                        name="applyOption"
                        label="Solo aplicar al producto actual"
                        checked={!applyToAll}
                        onChange={() => setApplyToAll(false)}
                        className="mb-3"
                    />
                    
                    <Form.Check
                        type="radio"
                        id="apply-criteria"
                        name="applyOption"
                        label="Aplicar también a productos que cumplan los siguientes criterios:"
                        checked={applyToAll}
                        onChange={() => setApplyToAll(true)}
                        className="mb-3"
                    />

                    {applyToAll && (
                        <div className="ms-4">
                            <ProductSelector
                                initialTypeId={product?.type?.id}
                                initialModelId={product?.model?.id}
                                initialColorId={product?.color?.id}
                                initialSizeId={product?.size?.id}
                                onSelectionChange={handleSelectionChange}
                                onFieldChange={handleCriteriaChange}
                            />
                            
                            <Alert variant="secondary" className="mt-3">
                                <small>
                                    <strong>Se aplicará a:</strong> {getCriteriaDescription()}
                                </small>
                            </Alert>
                        </div>
                    )}
                </Card.Body>
            </Card>
            
            <div className="d-flex justify-content-between">
                <Button variant="outline-secondary" onClick={onBack}>
                    ← Volver a Edición
                </Button>
                <Button variant="primary" onClick={handleApply}>
                    Aplicar Cambios
                </Button>
            </div>
        </>
    );

    if (embedded) {
        return content;
    }

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Aplicar Cambio de Puntuación</Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                {content}
            </Modal.Body>
        </Modal>
    );
};

export default ScoreUpdateModal;